import LegalLayout, { COMPANY } from "./LegalLayout";

export default function MesafeliSatis() {
  return (
    <LegalLayout eyebrow="Yasal Belge" title="Mesafeli Satış Sözleşmesi" updated="8 Şubat 2026">
      <h2>1. Taraflar</h2>
      <p><strong>Satıcı:</strong> {COMPANY.legalName} ({COMPANY.brand} markası ile).</p>
      <ul>
        <li><strong>Adres:</strong> {COMPANY.address}</li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
        <li><strong>E-posta:</strong> {COMPANY.email}</li>
        <li><strong>Web:</strong> {COMPANY.website}</li>
      </ul>
      <p><strong>Alıcı:</strong> {COMPANY.brand} platformuna üye olan ve abonelik hizmeti satın alan kullanıcı (bundan sonra "Alıcı" olarak anılacaktır).</p>

      <h2>2. Sözleşmenin Konusu</h2>
      <p>İşbu sözleşmenin konusu, Alıcı'nın Satıcı'ya ait <strong>{COMPANY.website}</strong> alan adlı internet sitesi üzerinden elektronik ortamda siparişini verdiği aşağıda nitelikleri ve satış fiyatı belirtilen dijital abonelik hizmetinin satışı ve teslimine ilişkin olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin belirlenmesidir.</p>

      <h2>3. Sözleşme Konusu Hizmet</h2>
      <ul>
        <li><strong>Hizmet Adı:</strong> {COMPANY.brand} Standart Plan (Aylık Abonelik)</li>
        <li><strong>Hizmet Türü:</strong> Bulut tabanlı SaaS (Yazılım Hizmeti) — kuyumcu ve döviz bürosu yönetim platformu</li>
        <li><strong>Ücret:</strong> 2.000,00 TL / ay (KDV dahil)</li>
        <li><strong>Ödeme Aracısı:</strong> PayTR Ödeme Hizmetleri A.Ş. (3D Secure destekli sanal POS)</li>
        <li><strong>Ödeme Aracı:</strong> Visa, Mastercard, Troy destekli kredi/banka kartları</li>
        <li><strong>Yenilenme Dönemi:</strong> Her ay otomatik olarak yenilenir</li>
      </ul>

      <h2>4. Genel Hükümler</h2>
      <p><strong>4.1.</strong> Alıcı, sözleşme konusu hizmetin temel nitelikleri, satış fiyatı, ödeme şekli ve ifaya ilişkin ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.</p>
      <p><strong>4.2.</strong> Sözleşme konusu hizmet, dijital nitelikte olup satın alım sonrası otomatik olarak Alıcı'nın hesabına anında aktive edilir. Herhangi bir fiziksel teslim veya kargo işlemi söz konusu değildir.</p>
      <p><strong>4.3.</strong> Alıcı'nın kredi kartından tahsil edilen tutar aboneliğin geçerli olduğu ay için tahakkuk eder. Sonraki dönem otomatik olarak yenilenir.</p>

      <h2>5. Cayma Hakkı</h2>
      <p>Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesinin (ğ) bendi uyarınca; elektronik ortamda anında ifa edilen ve tüketiciye anında teslim edilen gayri maddi mallara ilişkin sözleşmelerde <strong>cayma hakkı bulunmamaktadır</strong>. Bununla birlikte, {COMPANY.brand} kullanıcılarına <strong>ilk 3 gün</strong> içinde koşulsuz iade hakkı tanır (bkz. İptal ve İade Koşulları).</p>

      <h2>6. Fikri Mülkiyet Hakları</h2>
      <p>{COMPANY.brand} platformunda yer alan tüm yazılım, tasarım, marka, logo, içerik ve diğer fikri mülkiyet unsurları Satıcı'ya aittir. Alıcı, hizmeti yalnızca abonelik süresi boyunca ve kişisel/kurumsal iş kullanımı amacıyla kullanma hakkına sahiptir.</p>

      <h2>7. Yetkili Mahkeme</h2>
      <p>İşbu sözleşmenin uygulanmasında, T.C. Ticaret Bakanlığı'nca ilan edilen değere kadar Tüketici Hakem Heyetleri, ilan edilen değerin üzerindeki uyuşmazlıklarda <strong>Hatay Tüketici Mahkemeleri</strong> ve <strong>Hatay İcra Daireleri</strong> yetkilidir.</p>

      <h2>8. Yürürlük</h2>
      <p>Alıcı, siteden yaptığı elektronik satın alma işlemi ile birlikte işbu sözleşmenin tüm koşullarını kabul etmiş sayılır.</p>
    </LegalLayout>
  );
}
